/* Early Black Friday — Subscribe & Save panel: compact, red, with a tick that
   actually reflects the on/off state. Duplicated 2.0 product only. */
(function () {
  'use strict';
  if (location.pathname.indexOf('breathefree-2-0-resistance-necklace-early-black-friday') === -1) return;

  var CSS = [
    /* panel */
    '.rsb .rsb-subs{position:relative!important;border:2px solid #c8102e!important;border-radius:12px!important;background:linear-gradient(180deg,#fff5f6 0%,#fffaf8 60%)!important;box-shadow:0 10px 24px -16px rgba(200,16,46,.5)!important;padding:9px 11px!important;margin-top:10px!important}',
    '.rsb .rsb-subs.ebf-has-flag{padding-top:34px!important}',
    '.rsb .rsb-subs.is-off{border-style:solid!important;border-color:#e3a9b2!important;background:#fff!important}',

    /* header strip — one line */
    '.rsb .ebf-subs-flag{position:absolute;top:0;left:0;right:0;display:flex;align-items:center;justify-content:center;gap:6px;background:linear-gradient(90deg,#8f0a1e,#c8102e 50%,#8f0a1e);color:#fff;font-size:10px;font-weight:800;letter-spacing:.1em;text-transform:uppercase;padding:6px 10px;border-radius:9px 9px 0 0;line-height:1.2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;z-index:3}',
    '.rsb .ebf-subs-flag i{font-style:normal;font-size:11px;line-height:1}',

    /* tick: red only when ON */
    '.rsb .rsb-subs:not(.is-off) .rsb-check{width:22px!important;height:22px!important;min-width:22px!important;flex:none!important;border-radius:6px!important;background:#c8102e!important;border:2px solid #a50c23!important;box-shadow:0 0 0 3px rgba(200,16,46,.16)!important;color:#fff!important;display:flex!important;align-items:center!important;justify-content:center!important}',
    '.rsb .rsb-subs:not(.is-off) .rsb-check svg{width:13px!important;height:13px!important;display:block!important;color:#fff!important;stroke:#fff!important;stroke-width:3.4!important;opacity:1!important}',
    '.rsb .rsb-subs.is-off .rsb-check{width:22px!important;height:22px!important;min-width:22px!important;flex:none!important;border-radius:6px!important;background:#fff!important;border:2px solid #c9b4a0!important;box-shadow:none!important}',
    '.rsb .rsb-subs.is-off .rsb-check svg{display:none!important}',

    '.rsb .rsb-subs__title{font-size:14px!important}',
    '.rsb .rsb-subs__txt{font-size:11px!important}',

    /* gifts: tighter */
    '.rsb .rsb-sg__top{margin-bottom:6px!important}',
    '.rsb .rsb-sg__h{font-size:12.5px!important;font-weight:800!important}',
    '.rsb .rsb-sg__val{background:#c8102e!important;color:#fff!important;font-weight:800!important;font-size:9.5px!important;padding:2px 8px!important}',
    '.rsb .rsb-sg__grid{align-items:stretch!important;gap:6px!important;padding-top:4px!important}',
    '.rsb .rsb-gift{min-height:92px!important;padding:14px 5px 6px!important;justify-content:flex-start!important;border-color:#f0c5cb!important;background:#fff!important}',
    '.rsb .rsb-gift__img{width:26px!important;height:26px!important}',
    '.rsb .rsb-gift__t{min-height:2.3em!important;font-size:9.5px!important;display:flex!important;align-items:center!important;justify-content:center!important;text-align:center!important;overflow-wrap:anywhere}',
    '.rsb .rsb-gift__p{margin-top:auto!important;font-size:9px!important}',
    '.rsb .rsb-gift__rib{background:#c8102e!important;color:#fff!important;font-weight:800!important;letter-spacing:.06em!important;font-size:7.5px!important;padding:2px 6px!important}',

    '@media(max-width:600px){.rsb .ebf-subs-flag{font-size:9px;letter-spacing:.06em;padding:6px 8px}.rsb .rsb-subs.ebf-has-flag{padding-top:32px!important}.rsb .rsb-gift{min-height:98px!important}.rsb .rsb-gift__img{width:30px!important;height:30px!important}.rsb .rsb-gift__t{font-size:10px!important}}'
  ].join('');

  var st = document.createElement('style');
  st.id = 'bf-subs-highlight-css';
  st.textContent = CSS;
  (document.head || document.documentElement).appendChild(st);

  function decorate() {
    if (st.parentNode !== document.body && document.body) document.body.appendChild(st);
    var subs = document.querySelector('.rsb .rsb-subs');
    if (!subs) return;
    if (subs.querySelector('.ebf-subs-flag')) { subs.classList.add('ebf-has-flag'); return; }
    var flag = document.createElement('div');
    flag.className = 'ebf-subs-flag';
    flag.innerHTML = '<i>⚡</i><span>Black Friday Offer — Free Gifts</span>';
    subs.insertBefore(flag, subs.firstChild);
    subs.classList.add('ebf-has-flag');
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; decorate(); });
  }

  function start() {
    decorate();
    var root = document.querySelector('[data-rsb]');
    if (root) new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    document.addEventListener('change', schedule, true);
    document.addEventListener('click', schedule, true);
    setInterval(decorate, 800);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
